<template>
	<div style="overflow:hidden;">
		<div>
			<span class="xbed-sub-title">企业管理</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem href="/">企业管理</BreadcrumbItem>
				<BreadcrumbItem>企业信息</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<section style="min-height:500px">
			<Form inline>
				<FormItem label="注册日期" :label-width="75">
					<DatePicker style="width:220px" type="daterange" :clearable="false" v-model="registrationDate"></DatePicker>
				</FormItem>
				<FormItem label="消费日期" :label-width="75">
					<DatePicker style="width:220px" type="daterange" :clearable="false" v-model="consumeDate"></DatePicker>
				</FormItem>
				<FormItem label="推广负责员" :label-width="85">
					<Input v-model="condition.extensionClerk"></Input>
				</FormItem>
				<FormItem>
					<Button @click="queryData" type="primary">查找</Button>
					<Button @click="exportReport" :loading="exportBtn" type="success">导出数据</Button>
				</FormItem>
			</Form>
			<Table :columns="columns" :data="list"></Table>
			<Page show-sizer :current="condition.page" :page-size="condition.size" :total="count" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
		</section>
	</div>
</template>

<script>
import API from '../../api';
import Utils from "../../utils";
import Config from '@/config';
import Moment from 'moment';
export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.queryData()
	},
	data() {
		return {
			exportBtn: false,
			condition: {
				consumeEndfDate: '',
				consumeStartDate: '',
				extensionClerk: '',
				page: 1,
				registrationEndDate: '',
				registrationStartDate: '',
				size: 10,
			},
			count: 0,
			list: [],
			registrationDate: [Moment().subtract( 7, 'days' ).format( 'YYYY-MM-DD' ), Moment().format( 'YYYY-MM-DD' )],
			consumeDate: [Moment().subtract( 7, 'days' ).format( 'YYYY-MM-DD' ), Moment().format( 'YYYY-MM-DD' )],
			columns: [
				{
					title: '企业名称',
					width: 200,
					align: 'center',
					key: 'enterpriseName'
				},
				{
					title: '推广负责员',
					width: 200,
					align: 'center',
					key: 'extensionClerk'
				},
				{
					title: '城市',
					width: 150,
					align: 'center',
					key: 'city',
				},
				{
					title: '下挂会员数',
					width: 150,
					align: 'center',
					key: 'totalNum'
				},
				{
					title: '首次消费会员数',
					width: 150,
					align: 'center',
					key: 'firstConsumeNum'
				},
				{
					title: '消费会员数',
					width: 150,
					align: 'center',
					key: 'totalConsumeNum'
				},
				{
					title: '日结金额',
					width: 150,
					align: 'center',
					key: 'dayAmount',
					render: ( h, param ) => {
						return h( 'span', {}, ( param.row.dayAmount / 100 ).toFixed( 2 ) )
					}
				},
				{
					title: '总房晚',
					width: 100,
					align: 'center',
					key: 'totalNight'
				},
			]
		}
	},
	methods: {
		changePageSize( pageSize ) {
			this.condition.page = 1;
			this.condition.pageSize = pageSize;
			this.queryData();
		},
		changePage( page ) {
			this.condition.page = page;
			this.queryData();
		},
		queryData() {
			this.condition.consumeStartDate = this.consumeDate.length > 0 ? Moment( this.consumeDate[0] ).format( 'YYYY-MM-DD' ) : '';
			this.condition.consumeEndfDate = this.consumeDate.length > 0 ? Moment( this.consumeDate[1] ).format( 'YYYY-MM-DD' ) : '';
			this.condition.registrationStartDate = this.registrationDate.length > 0 ? Moment( this.registrationDate[0] ).format( 'YYYY-MM-DD' ) : '';
			this.condition.registrationEndDate = this.registrationDate.length > 0 ? Moment( this.registrationDate[1] ).format( 'YYYY-MM-DD' ) : '';
			this.queryPromotionReport();
		},
		async queryPromotionReport() {
			let resp = ( await API.omsAPI[this.env].enterpriseModule.queryCompanyUserReport(
				this.condition,
				this.token
			) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: '获取报表失败',
					desc: resp.msg
				} )
			} else {
				this.count = resp.total;
				this.list = resp.content;
			}
		},
		async exportReport() {
			let param = {
				consumeEndfDate: this.condition.consumeEndfDate,
				consumeStartDate: this.condition.consumeStartDate,
				extensionClerk: this.condition.extensionClerk,
				registrationEndDate: this.condition.registrationEndDate,
				registrationStartDate: this.condition.registrationStartDate,
			}
			let url = `${ Config[this.env].analysisUrl }excel/exportPromotionReport?consumeEndfDate=${ param.consumeEndfDate }&consumeStartDate=${ param.consumeStartDate }&extensionClerk=${ param.extensionClerk }&registrationEndDate=${ param.registrationEndDate }&registrationStartDate=${ param.registrationStartDate }`;
			// window.open(url);
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/business-management/promotion-report.vue